import { FC } from 'react';
import { Question as QuestionType } from '@jbc-year-end-adj/2024/features/questions/types';
import { Start } from './Start';
import { ResignInYear } from './ResignInYear/ResignInYear';
import { MultiCompanies } from './MultiCompanies/MultiCompanies';
import { SalaryMore } from './SalaryMore/SalaryMore';
import { SalaryMoreNext } from './SalaryMoreNext/SalaryMoreNext';
import { BasicInfos } from './BasicInfos/BasicInfos';
import { Householder } from './Householder/Householder';
import { FormerJobs } from './FormerJobs/FormerJobs';
import { Income } from './Income/Income';
import { SalaryIncome } from './SalaryIncome/SalaryIncome';
import { OtherIncomeType } from './OtherIncomeType/OtherIncomeType';
import { AllIncome } from './AllIncome/AllIncome';
import { WorkingStudent } from './WorkingStudent';
import { Handicap } from './Handicap';
import { SpouseLivingStatus } from './SpouseLivingStatus';
import { Widow } from './Widow';
import { Spouse } from './Spouse';
import { HasDependent } from './HasDependent';
import { Dependents } from './Dependents';
import { HasInsurances } from './HasInsurances';
import { LifeInsurances } from './LifeInsurances';
import { EarthquakeInsurances } from './EarthquakeInsurances';
import { SocialInsurances } from './SocialInsurances';
import { Premium } from './Premium';
import { HousingLoan } from './HousingLoan';
import { Attachments } from './Attachments';
import { Finish } from './Finish';

// @ts-ignore
import { Redirect } from 'react-router';

type QuestionProps = {
  currentQuestion?: QuestionType;
  firstNotAnsweredQuestion?: QuestionType;
  questionsByCode: { [key: string]: QuestionType };
};

export const Question: FC<QuestionProps> = ({ currentQuestion, firstNotAnsweredQuestion }) => {
  const currentQuestionNotExist = !currentQuestion;
  const currentQuestionSkipped = currentQuestion?.requestQuestion?.status === 'skipped';
  const notFirstAnsweredBeforeQuestionExist =
    firstNotAnsweredQuestion && currentQuestion && currentQuestion.no > firstNotAnsweredQuestion.no;

  if (currentQuestionNotExist || currentQuestionSkipped || notFirstAnsweredBeforeQuestionExist) {
    if (firstNotAnsweredQuestion) {
      return <Redirect to={`/employee_input?current=${firstNotAnsweredQuestion.code}`} />;
    } else {
      // return <Finish isAdjTarget={questionsByCode['basic_infos']?.requestQuestion?.status === 'answered'} />;
      return <Finish />;
    }
  }

  switch (currentQuestion.code) {
    case 'start':
      return <Start question={currentQuestion} />;
    case 'resign_in_year':
      return <ResignInYear question={currentQuestion} />;
    case 'multi_companies':
      return <MultiCompanies question={currentQuestion} />;
    case 'salary_more':
      return <SalaryMore question={currentQuestion} />;
    case 'salary_more_next':
      return <SalaryMoreNext question={currentQuestion} />;
    case 'basic_infos':
      return <BasicInfos question={currentQuestion} />;
    case 'householder':
      return <Householder question={currentQuestion} />;
    case 'former_jobs':
      return <FormerJobs question={currentQuestion} />;
    case 'income':
      return <Income question={currentQuestion} />;
    case 'salary_income':
      return <SalaryIncome question={currentQuestion} />;
    case 'other_income_type':
      return <OtherIncomeType question={currentQuestion} />;
    case 'all_income':
      return <AllIncome question={currentQuestion} />;
    case 'working_student':
      return <WorkingStudent question={currentQuestion} />;
    case 'handicap':
      return <Handicap question={currentQuestion} />;
    case 'widow':
      return <Widow question={currentQuestion} />;
    case 'spouse_living_status':
      return <SpouseLivingStatus question={currentQuestion} />;
    case 'spouse':
      return <Spouse question={currentQuestion} />;
    case 'has_dependent':
      return <HasDependent question={currentQuestion} />;
    case 'dependents':
      return <Dependents question={currentQuestion} />;
    case 'has_insurances':
      return <HasInsurances question={currentQuestion} />;
    case 'life_insurances':
      return <LifeInsurances question={currentQuestion} />;
    case 'earthquake_insurances':
      return <EarthquakeInsurances question={currentQuestion} />;
    case 'social_insurances':
      return <SocialInsurances question={currentQuestion} />;
    case 'premium':
      return <Premium question={currentQuestion} />;
    case 'housing_loan':
      return <HousingLoan question={currentQuestion} />;
    case 'attachments':
      return <Attachments question={currentQuestion} />;
    default:
      return null;
  }
};
